import axios from 'axios';
import apiConfig from '../config/apiConfig';

// Crear una instancia de Axios
const apiClient = axios.create({
    baseURL: apiConfig.baseURL,
    headers: apiConfig.defaultHeaders,
  });

// Interceptor de solicitud (para agregar tokens, por ejemplo si se utiliza)
    /* apiClient.interceptors.request.use(
        (config) => {
        const token = localStorage.getItem('token'); // Ejemplo: obtener token del almacenamiento local
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
        },
        (error) => Promise.reject(error)
    ); */
  
// Interceptor de respuesta (para manejar errores globales)
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('Error en la respuesta:', error.response || error.message);
      return Promise.reject(error);
    }
  );
  
  export default apiClient;